exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination{width:100%}.pagination-list{list-style-type:none;margin:50px 0;text-align:center}.pagination-item{display:inline}.pagination-btn{font-size:15px;font-weight:700;margin:0 5px;padding:10px;border:none;cursor:pointer}.active{color:#ec4e00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c6dfa1f","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pagination.vue
// module id = vMAg
// module chunks = 1